<template>
	<div class="select-table-data-input block-editor-inputs-layout">
		<div class="prefix-icons">
			<span>
				<TableSvg />
			</span>
			<span class="service-icon" v-if="inputsNode && inputsNode.service_slug">
				<SIcon :name="inputsNode.service_slug" :height="9" :width="9" />
			</span>
		</div>
		<div class="suffix-icons index">
			<RoundButton v-if="validValue" @click="localValue = ''"><div class="close-x"></div></RoundButton>
		</div>
		<CombinedInputFieldDataMenu
			:value.sync="localValue"
			:placeholder="placeholder"
			readonly
			:textAreaMode="false"
			:multipleSelection="false"
			:inputSize="'sm'"
			:valuesTypes="dataInputMenuValueTypes"
		/>
	</div>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import CombinedInputFieldDataMenu from '../CombinedInputFieldDataMenu';
import TableSvg from '../TableSvg.vue';
import ParamsService from '@/utils/ParamsService';
import VModelMixin from '@/mixins/VModelMixin';
import TableOnlyAllowedValueTypesMixin from '../../BlockEditorWidget/FieldSettings/ValueTypesMixins/TableOnlyAllowedValueTypesMixin';
import { getNodeByUuidForSelectedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
export default {
	name: 'SelectTableDataInput',
	mixins: [VModelMixin, TableOnlyAllowedValueTypesMixin],
	components: {
		CombinedInputFieldDataMenu,
		TableSvg,
	},
	props: {
		inputFieldHint: { type: [String, Number] },
	},
	computed: {
		...mapGettersShorthand({ getNodeByUuidForSelectedWorkflowVersion }),
		inputsNode() {
			const selectedNodeUUID = ParamsService.extractNodeUUIDFromValue(this.localValue);
			return this.getNodeByUuidForSelectedWorkflowVersion(selectedNodeUUID);
		},
		placeholder() {
			return this.inputFieldHint ? this.inputFieldHint : 'Choose table';
		},
		validValue() {
			return !isNullOrUndefinedOrEmpty(this.localValue);
		},
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.select-table-data-input {
	@import '../../BlockEditor/BlockEditorParams/block-editor-inputs-layout.scss';
	position: relative;

	.service-icon {
		position: absolute;
		top: -1px;
		left: 19px;
		padding: 0 6px;
		border: var(--seconday-border);
		border-radius: 5px;

		> .inline-block {
			transform: translate(0, -3px);
		}
	}
	.close-x {
		transform: translate(-1px, 0);
	}

	::v-deep {
		.ProseMirror {
			padding-left: 34px !important;

			.is-empty {
				margin-left: -20px;
			}
		}
	}
}
.index {
	z-index: 1;
}
</style>
